import { Component} from '@angular/core';
import { AlertService } from '../../../../services/notify/alert.service';
import { ContractsService } from '../../../../services/api/contracts.service';
import { FinanceWalletModel } from '../../../../models/finance.model';
import { ContractFinanceService } from '../../services/contract-finance.service';
import { ContractDataService } from '../../services/contract-data.service';
import { IContractDataModel } from '../../models/contract-internal-models';
import { MatDialogRef } from '@angular/material/dialog';
import { TFormState } from '../../../../models/forms.model';

@Component({
    selector: 'app-contract-block-finance-wallet-select',
    templateUrl: './contract-block-finance-wallet-select.component.html',
    styleUrl: './contract-block-finance-wallet-select.component.scss',
 
})
export class AppContractBlockFinanceWalletSelectComponent {
    public availableWallets:{title:string,guid:string}[] = []
    public contractData:IContractDataModel|null = null
    public selectedWallet: FinanceWalletModel | null = null;
		public formState:TFormState = 'Default'
    constructor (
        private alertService:AlertService,
        private contractsService:ContractsService,
        private contractFinanceService:ContractFinanceService,
        private contractDataService:ContractDataService,
				private dialogRef:MatDialogRef<AppContractBlockFinanceWalletSelectComponent>
    ) {
		}
    changeContractWallet(): void {
			this.formState = 'Submitting'
			this.contractsService.changeContractWallet(this.contractData?.contract?.contract.guid, this.selectedWallet?.guid).subscribe({
				next: res => {
					this.formState = 'Default'
					let curProjectGuid = this.contractData!.currentProjectGuid
					let curWalet = this.contractData?.contract?.projects.find(el=>el.project.guid===curProjectGuid)?.wallet_guid
					let curWaletPrivate = this.contractData?.contract?.privates.find(el=>el.member.guid===curProjectGuid)?.wallet_guid
          let currentWallet =  curWalet||curWaletPrivate
          currentWallet = this.selectedWallet?.guid
					this.alertService.setAlert(res.message, 'green');
					this.dialogRef.close(true)
				}, error: (err:any) => {
						this.formState = 'Default'
						this.alertService.setAlert(err.message, 'blue');
				},
			}); 
    }
}